var $ = {}
if (process.browser) {
  $ = require('zepto')
}

export default $



// WEBPACK FOOTER //
// ./src/mods/$.js